import React from 'react'
import TopBar from '../bars/top-bar'
import BackIconButton from '../buttons/BackIconButton'
import HeadingBeta from '../headings/heading-beta'
import InfoBlock from '../texts/info-block'

const createTopBarLeftChildren = props => {
  const topBarLeftChildren = [<BackIconButton key='BackIconButton' />]
  return topBarLeftChildren
}

const Terms = props => {
  return (
    <div className='detail-item inner-wrapper-wide'>
      <TopBar
        theme='light-bar'
        leftChildren={createTopBarLeftChildren(props)}
      />
      <HeadingBeta className='bottom-space'>Terms and Conditions</HeadingBeta>
      <InfoBlock>
        <p className='section-subtitle'>Charities</p>
        <p>
          Charities must be verified by Chair-bids llc through a fed tax id #.
          Chair-bids reserves the right to decline service to any individual or
          organization that doesn’t qualify or isn’t registered as a non-profit
          under federal laws of the United States of America.
        </p>
        <p>
          Charities are charged a 10% fee on all transactions processed through
          Chair-Bids, Chair-Bids will contribute at least 1 auction item free of
          charge for the charity to include in their Auction. Chair-bids will
          also help Charities to obtain auction items to include in their
          Auction. Charities are responsible for all shipping as well as
          verifying the authenticity of the items they put up for auction, as
          well as the content they include in description of items.
        </p>
      </InfoBlock>
      <InfoBlock>
        <p className='section-subtitle'>Users</p>
        <p>
          Users are not charged a fee for bidding, but may be charged an
          additional shipping charge. Bidders are required to have a valid
          credit card in order to bid. Credit card will be authorized in order
          to bid, but won’t be charged until an item is officially won at the
          close of an auction. Chair-bids does not guarantee the authenticity of
          any memorabilia, or autographs purchased on the site. All experiences
          or items won, must be coordinated through the charity in which it was
          purchased from. All Sales are final once an item is won and auction is
          closed.
        </p>
        <p>
          Chair-bids reserves the right to deny any user from the site for
          violations, including, but not limited to, not paying for winning bid.
        </p>
      </InfoBlock>
    </div>
  )
}

export default Terms



// WEBPACK FOOTER //
// ./src/ui/views/terms.js